import { isServer } from '@/helpers/Platform/Platform';

export enum InteractionEvent {
  LOAD = 'load',
  GENERIC_INTERACTION = 'generic_interaction',
  VIRTUAL_PAGEVIEW = 'virtual_pageview',
  FOOTER_CLICK = 'footer_interaction',
  HEADER_CLICK = 'header_interaction',
}

export enum EventLabel {
  SIDEBAR = 'sidebar',
  TAB_NAVIGATION = 'tab_navigation',
}

export enum EventAction {
  OPEN_MY_ACCOUNT = 'open_my_account',
}

export enum InteractionContainerDetail {}

export enum InteractionGoal {}

export enum InteractionContainerName {}

export enum InteractionElement {}

export type TrackingParameterValue =
  | string
  | number
  | undefined
  | boolean
  | InteractionContainerDetail
  | InteractionEvent
  | InteractionGoal
  | InteractionContainerName
  | InteractionElement;

export interface TrackingData {
  eventAction: string;
  eventLabel: string;
  contentLanguage?: string;
}

export function isGTMEnabled(): boolean {
  return !isServer() && !!window.dataLayer;
}

export function trackEvent(
  eventName: string,
  eventParams: Record<string, TrackingParameterValue> = {},
): void {
  if (!isGTMEnabled()) {
    return;
  }
  window.dataLayer.push({
    event: eventName,
    ...eventParams,
  });
}
